/**
 * The Pro features' wall (api/services/pro_features.py): series and recurring
 * characters (and scene clips, which their pages handle themselves). A free
 * account that reaches for one sees the one upgrade offer, opened by
 * components/upgrade/ProWall.jsx, from a button that asks first (`proAllowed`)
 * or from the API's refusal ({code: "<feature>_requires_pro"}, api/client.js).
 */
export const PRO_CODES = { series_requires_pro: 'series', characters_require_pro: 'characters' };

export const PRO_WALL_EVENT = 'pro-wall';

/** Open the offer for a Pro feature (`series`, `characters`). */
export function proWall(reason, from = '') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PRO_WALL_EVENT, { detail: { reason, from } }));
}

/** Whether the account may use a Pro feature, from /usage/metrics; true while not known (an older API). */
export const proAllowed = (metrics, feature) => metrics?.[feature]?.allowed !== false;
